(() => {
	angular
		.module('main')
		.directive(
			'addExtraShootWithoutScheduleModal',
			addExtraShootWithoutScheduleModal
		);

	addExtraShootWithoutScheduleModal.$inject = [
		'workflowService',
		'messageService',
		'validationService'
	];

	function addExtraShootWithoutScheduleModal(
		workflowService,
		messageService,
		validationService
	) {
		return {
			restrict: 'E',
			scope: {
				extraShoot: '<',
				taskList: '=',
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: `<section>
                        <div id="extraShootWithoutScheduleModal" class="modal modal-center fade modal-appointment-lx" data-backdrop="static"
                             data-keyboard="false">
                            <div class="modal-dialog modal-dialog-datepicker">
                                <form ng-submit="saveExtraShoot(extraShoot, taskList, extraShoot.id)">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <btn-close></btn-close>
                                            <h3 class="modal-title">{{extraShoot.id ? 'Edit':'Add'}} {{extraShootLabelName | lowercase}}</h3>
                                        </div>
                                        <div class="modal-body f-s-14-i" style="padding-bottom: 15px !important">
                                            <h3 class="mt-0 mb-25">{{extraShootLabelName}} details</h3>
                                            <div class="flex-row flex-wrap-xs flex-align-center mb-30">
                                                <div class="pr-30">
                                                    <p>Name</p>
                                                </div>
                                                <div class="flex-grow-1 flex-with-full mb-10">
                                                    <input type="text" autocomplete="off" class="form-control" name="extraShootName" maxlength="255" ng-model="extraShoot.name"
                                                           required>
                                                </div>
                                            </div>
                                            <div class="flex-row">
                                                <p>
                                                    Update {{extraShootLabelName | lowercase}} schedule, including date range, time range and location, from within your job profile, once you have applied this workflow to a job.
                                                </p>
                                            </div>
                                        </div>
                                        <div class="modal-footer modal-foot">
                                            <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"
                                                    spinning-wheel is-spinning-wheel-active="isUpdateSpinnningWheelActive">Save {{extraShootLabelName | lowercase}}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
             `,
			replace: true,
			transclude: true,
			link(scope) {
				const extraShootModal = '#extraShootWithoutScheduleModal';

				$(document)
					.on('show.bs.modal', extraShootModal, () => {
						scope.taskInfo = workflowService.getTaskInfo();
						scope.isForEdit = scope.taskInfo.isForEdit;
						scope.extraShoot = angular.copy(scope.taskInfo.task);
						scope.$evalAsync();
					})
					.on('shown.bs.modal', extraShootModal, function() {
						$(this)
							.find('input')
							.first()
							.focus();
						const input = $(this).find('input');

						validationService.isModalClosePrevented(input);
					});

				scope.saveExtraShoot = (extraShoot, taskTypes, id) => {
					scope.button_disable = true;

					const isEdited = id !== null && id !== undefined;

					if (!workflowService.isTaskValid(extraShoot)) {
						scope.button_disabled = false;
						return;
					}

					if (!extraShoot.eventType) {
						extraShoot.eventType = 'EXTRA_SHOOT';
					}

					scope.taskList = workflowService.pasteNewTaskInList(
						taskTypes,
						extraShoot
					); // modifies workflow list
					scope.taskList = workflowService.renewTaskViewDue(scope.taskList);

					isEdited
						? messageService.showToaster('s_4', 'workflow')
						: messageService.showToaster('s_3', 'workflow');

					scope.button_disable = false;

					$(extraShootModal).modal('hide');
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addExtraShootWithoutScheduleModal.js